<template>
  <div>
    <h3>Campus</h3>
    <vs-tabs
      position="left"
      class="tabs-shadow-none mt-2"
      id="profile-tabs"
      :key="isSmallerScreen"
    >
      <!--<vs-tab icon-pack="feather" icon="icon-info" :label="!isSmallerScreen ? 'Campus reports' : ''">
        <div class="lists-view-tab">
          <campus-reports />
        </div>
      </vs-tab>-->
      <vs-tab
        icon-pack="feather"
        icon="icon-activity"
        :label="!isSmallerScreen ? 'Campus level changes' : ''"
      >
        <div class="lists-view-tab">
          <campus-level-changes />
        </div>
      </vs-tab>

      <vs-tab
        icon-pack="feather"
        icon="icon-dollar-sign"
        :label="!isSmallerScreen ? 'Planday payrate changes' : ''"
      >
        <div class="lists-view-tab">
          <payrate-planday-changes />
        </div>
      </vs-tab>

      <vs-tab
        icon-pack="feather"
        icon="icon-users"
        label="Employees"
        v-if="$AuthService.hasPermission('vp.campus.campus.employees')"
      >
        <div class="lists-view-tab">
          <employee-reports />
        </div>
      </vs-tab>
    </vs-tabs>
  </div>
</template>

<script>
/*import CampusReports from "./CampusReports/CampusReports.vue";*/
import EmployeeReports from "./Employees/EmployeeReports.vue";
import CampusLevelChanges from "./CampusLevelChanges/CampusLevelChanges.vue";
import PayratePlandayChanges from "./PayratePlandayChanges/PayratePlandayChanges.vue";

export default {
  components: {
    /*CampusReports,*/
    EmployeeReports,
    CampusLevelChanges,
    PayratePlandayChanges,
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    // clickRoute(routeName) {
    //   this.$router.replace({ name: "lists", params: { listname: routeName } });
    // },
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768;
    },
    // routeNameToIndex() {
    //   const name = this.$route.params.listname;
    //   console.log("ROUTE NAME", name);
    //   switch (name) {
    //     case "visits":
    //       return 0;
    //     case "eodreports":
    //       return 1;
    //     default:
    //       return 0;
    //   }
    // },
  },
};
</script>

<style lang="scss">
.lists-view-tab {
  margin-left: 12px;
}
</style>
